export const environment = {
    production: false,
    domainBackEnd:".",
    APIKey: "3_lCFuP8NUDhIZ0RsuXm9i_jbZSkhhV9b4PU-pZDxk4sS84KXn7TcDhs7sD5zM0KGq"//#gitleaks:allow
};
